export enum OperationType {
    Franchise = 1,
    Retail = 2
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_entities/operation-type.ts